export const classes = {
  button:
    'place-start h-12 rounded-nav overflow-hidden select-none transition-colors cursor-pointer whitespace-nowrap',
  active: 'bg-mint-2 text-sage-10',
  inactive: 'text-sage-7 hover:bg-mint-2/[.18] hover:text-mint-2',
  iconWrapper: 'place-center w-12 h-12 shrink-0',
  icon: 'shrink-0',
  label: 'text-base font-bold pr-4',
};
